define(["require", "exports", "./localDateUtil"], function (require, exports, localDateUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    localDateUtil_1.formatDocumentToLocalDate();
});
